import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import AssignmentDetails from '../details/AssignmentDetails'
import AssignmentSummary from '../summary/AssignmentSummary'
import AssignmentNotesContainer from '../notes/AssignmentNotesContainer'
import AssignmentDocumentContainer from '../documents/AssignmentDocumentContainer'
import CorrespondenceHistory from '../correspondence/CorrespondenceHistory'
import AsssignmentHeader from './AssignmentHeader'
import InitialQuestionsForm from '../initial-questions/InitialQuestionsForm'

const APPRAISAL_ASSISTANCE = `appraisalAssistance`

export const RenderAssignmentPages = ({ assignmentCorrespondence, assignmentDetails, url, pathname, serverProperties }) => {

  const mustRedirect = mustRedirectToInitialQuestions(assignmentDetails, pathname, serverProperties)
  return <div className='assignment-overview' hidden={assignmentDetails.fetching || assignmentDetails.error}>
    <AsssignmentHeader assignmentDetails={assignmentDetails} />
    <div className='assignment-content'>

      {mustRedirect ? <Redirect to={`${url}/${APPRAISAL_ASSISTANCE}`} /> : <>
        <Route
          exact
          path={url}
          render={() => <AssignmentSummary
            assignmentDetails={assignmentDetails}
            assignmentCorrespondence={assignmentCorrespondence} />} />
        <Route exact
          path={`${url}/${APPRAISAL_ASSISTANCE}`} component={InitialQuestionsForm} />
        <Route
          exact
          path={`${url}/details`}
          render={() => <AssignmentDetails
            assignmentDetailPayload={assignmentDetails} />} />
        <Route
          exact
          path={`${url}/notes`}
          render={() => <AssignmentNotesContainer
            propertyAppraisalId={assignmentDetails.id}
            lin={assignmentDetails.lin} />} />
        <Route
          exact
          path={`${url}/documents`}
          render={() => <AssignmentDocumentContainer
            assignmentDetails={assignmentDetails}
            assignmentCorrespondence={assignmentCorrespondence} />} />
        <Route
          exact
          path={`${url}/correspondence`}
          render={() => <CorrespondenceHistory
            assignmentDetails={assignmentDetails} />} />
      </>}
    </div>
  </div>
}

function mustRedirectToInitialQuestions(assignmentDetails, pathname, serverProperties) {
  //Don't redirect to the Appraisal Assistance page if we are already on it.
  if (pathname.includes(APPRAISAL_ASSISTANCE)) {
    return false
  }
  if (!assignmentDetails) {
    return false;
  }
  //Only redirect for appraisals that have an out for appraisal date after 1/1/20
  const bwnDate = new Date("2020/01/01");
  let isAppraisalAfterBwn = true;
  if (assignmentDetails.latestOutForAppraisalDate < bwnDate.getTime()) {
    isAppraisalAfterBwn = false;
  }
  const qualificationPrice = assignmentDetails.salePrice > assignmentDetails.refinanceAmount ? assignmentDetails.salePrice : assignmentDetails.refinanceAmount

  if (assignmentDetails.aappUsed === null
    && assignmentDetails.traineeAllowed === true
    && (assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND')
    //TODO: Allowing disposition codes of P here is temporary until long-term solution is figured out
    && (assignmentDetails.dispositionCode === 'O' || assignmentDetails.dispositionCode === 'P' || assignmentDetails.dispositionCode === 'I')
    && isAppraisalAfterBwn
    && qualificationPrice < serverProperties.bwnsalerefinanceprice) {
    return true;
  }

}

export default RenderAssignmentPages
